export type CanvasListMainPhase = "boot" | "empty" | "busy" | "ready";

export function canvasListMainPhase(input: {
  listBusy: boolean;
  hasSelection: boolean;
  contentReady: boolean;
}): CanvasListMainPhase {
  if (input.listBusy) {
    return "boot";
  }
  if (!input.hasSelection) {
    return "empty";
  }
  if (!input.contentReady) {
    return "busy";
  }
  return "ready";
}
